import Dexie from 'dexie';
// import 'dexie-observable';
import { Observable } from 'rxjs';

export class DBService extends Dexie {

    constructor() {
        super('OneUI');
        this.version(1).stores({
            settings: '++id',
        });
        this.version(2).stores({});
            //         this.on('changes', function (changes) {
            //     changes.forEach(function (change) {
            //         switch (change.type) {
            //             case 1: // CREATED
            //                 console.log('An object was created: ' + JSON.stringify(change.obj);
            //                 break;
            //             case 2: // UPDATED                            
            //                 console.log(change.mods.lang);
            //                 break;
            //             case 3: // DELETED
            //                 console.log('An object was deleted: ' + JSON.stringify(change.oldObj));
            //                 break;
            //         }
            //     });

            // });
    }

}

